import { render } from "./error.vue?vue&type=template&id=2ccc843d"
const script = {}
script.render = render

export default script